export { ComparisonCards2 } from './ComparisonCards2'
